import styled from 'styled-components';
import { SYS_BREAKPOINT_XS, SYS_BREAKPOINT_SM, SYS_BREAKPOINT_MD, SYS_BREAKPOINT_LG, SYS_BREAKPOINT_XL, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_500, SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_XL, SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT, SYS_SPACE_FIXED_50, SYS_SIZE_FIXED_700, SYS_SPACE_RELATIVE_2_XS, } from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper } from '../../../utils';
export const CarInfoContainer = styled.div `
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  ${dynamicStylingHelper(`
    gap: ${SYS_SPACE_FIXED_350};
    @media (min-width: ${SYS_BREAKPOINT_XS}) {
      padding: 10px 5px;
    }
    @media (min-width: ${SYS_BREAKPOINT_SM}) {
      padding: 10px 10px;
    }
    @media (min-width: ${SYS_BREAKPOINT_MD}) {
      padding: 10px 20px;
    }
    @media (min-width: ${SYS_BREAKPOINT_LG}) {
      padding-top: 28px;
      padding-left: 40px;
      padding-right: 0;
    }
    @media (min-width: ${SYS_BREAKPOINT_XL}) {
      padding-top: 32px;
      padding-left: 56px;
      gap: ${SYS_SPACE_FIXED_500};
    }
  `, `
    padding-top: ${SYS_SPACE_RELATIVE_XL};
    gap:${SYS_SPACE_RELATIVE_XL};
  `)}
`;
export const VehicleDetailWrapper = styled.div ``;
export const KeyFeaturesContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: ${(props) => props.isPLP ? dynamicStylingHelper(SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_300) : ''};
`;
export const FeaturesListWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: ${dynamicStylingHelper(SYS_SPACE_FIXED_150, SYS_SPACE_RELATIVE_2_XS)};
  overflow: hidden;
  ${(props) => props.isPLP
    ? `
   ${dynamicStyling({
        legacy: `max-height: calc(2 * 28px + 12px);`,
        alpha: `
      height: calc(2 * ${SYS_SIZE_FIXED_700} + ${SYS_SPACE_RELATIVE_2_XS});
      align-items: flex-start;
    `,
    })};
`
    : ''};
`;
export const WarrantyContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
`;
export const AvailableBadgeWrapper = styled.div `
  margin: ${(props) => props.isPLP ? `0 0 ${dynamicStylingHelper(SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_300)} 0` : '0'};
`;
export const InfoItemsContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 5px;
`;
export const ListItemContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 5px;
`;
export const ItemContainer = styled.div `
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 4px;
`;
export const DealerLabelContainer = styled.div `
  display: flex;
  flex-direction: ${(props) => (props.isPLP ? 'row' : 'column')};
  margin-bottom: ${(props) => props.isPLP ? dynamicStylingHelper(SYS_SPACE_FIXED_350, SYS_SPACE_FIXED_300) : ''};
  gap: ${(props) => (props.isPLP ? SYS_SPACE_FIXED_50 : '')};
  flex-wrap: ${(props) => (props.isPLP ? 'wrap' : '')};

  & span {
    ${(props) => `${dynamicStylingHelper(`color: ${props.isPLP ? SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT : ''};`)}`}
  }
`;
